import Vue from 'vue';
import Router from 'vue-router';

export default () => {
  Vue.use(Router);

  const router = new Router({
    mode: 'history',
    base: '/ics/property/firsthand/',
    routes: [
      {
        path: '/',
        name: 'firsthandBuildingIndex',
        component: () => import('./search'),
      },
      {
        path: '/details/:id',
        name: 'firsthandDetail',
        component: () => import('./detail/Firsthand'),
      },
      {
        path: '/details/:id/:buildingName',
        name: 'firsthandDetailName',
        component: () => import('./detail/Firsthand'),
      },
    ],
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });

  return router;
};
